<template>
  <div>
    <h2>{{ $t('views.endusers.addresses.detail.title') }}</h2>

    <entity-detail-table
      :entityKey="eParent.key"
      :entityId="eParent.id"

      @control:input="onInput"
      @control:change="onChange"
      @entity:save="onSave"
    />

    <div class="mt-4">
      <h4 class="h5">{{ $t('views.endusers.addresses.action.delete.title') }}</h4>
      <b-button variant="danger" @click="showConfirmationModal = true">
        <b-icon icon="trash" /> {{ $t('views.endusers.addresses.button.deleteaddress') }}
      </b-button>
    </div>

    <b-modal
      v-if="showConfirmationModal"
      v-model="showConfirmationModal"
      :title="$t('views.endusers.addresses.popup.title')"
      hide-footer
    >
      <i18n path="views.endusers.addresses.popup.message">
        <template #address><b-badge variant="info">{{ addressLabel }}</b-badge></template>
        <template #br><br></template>
      </i18n>
      <div class="text-right">
        <b-button class="mr-2" variant="light" @click="closeConfirmation">{{ $t('views.endusers.addresses.popup.button.cancel') }}</b-button>
        <b-button variant="danger" :disabled="isDeleting" @click="deleteAddress">
          <loader v-if="isDeleting" inline />
          <b-icon v-else icon="trash" /> {{ $t('views.endusers.addresses.popup.button.delete') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { valueFormatter } from '@/assets/js/helper/entity';
import EntityDetailTable from '@/components/entity/DetailTable';
import Loader from '@/components/Loader';
import MixinEntityBase from '@/components/mixins/EntityBase';

export default {
  name: 'EndUsers.Addresses.Detail',
  mixins: [MixinEntityBase],
  components: {
    EntityDetailTable,
    Loader
  },
  data () {
    return {
      showConfirmationModal: false,
      isDeleting: false
    }
  },
  computed: {
    entity () {
      return this.$store.getters[`${this.eParent.key}/getEntity`](this.eParent.id) || null
    },
    definition () {
      return this.$store.getters[`${this.eParent.key}/definition`]
    },
    addressLabel () {
      const unwrapped = (this.entity || {}).value || {}
      const formatted = valueFormatter(this.definition, 'type', unwrapped.type)
      return formatted.value || unwrapped.type || ''
    }
  },
  methods: {
    onInput (controlValue) {
      /* do something with controlValue = { [propKey]: value } */
    },
    onChange (controlValue) {
      /* do something with controlValue = { [propKey]: value } */
    },
    onSave (entity) {
      this.$store.dispatch(`${this.eParent.key}/updateEntity`, entity)
    },
    closeConfirmation () {
      this.showConfirmationModal = false
    },
    async deleteAddress () {
      this.isDeleting = true
      try {
        await this.$store.dispatch(`${this.eParent.key}/removeEntity`, this.entity || { id: this.eParent.id })
        this.$router.push({ name: 'EndUsers.Addresses', params: { enduserid: this.$route.params.enduserid } })
      } finally {
        this.isDeleting = false
        this.closeConfirmation()
      }
    }
  }
}
</script>

<style lang="scss"></style>
